import api from 'ApiConfig';

const classService = {
  getClassesByYear: async (teacherId) => {
    return api.post('/teacher/get-classes-data', { teacherId });
  },
  getBatchDetails: async (courseId) => {
    return api.post('/teacher/get-batches-details', { courseId });
  },
  getCourses: async () => {
    return api.post('/teacher/get-courses');
  },
};

export default classService;
